import React, { useState } from 'react';
import "./travel_upload.css";
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import { useDispatch, useSelector } from 'react-redux';

export function Travel_Upload() {
  const [destination, setDestination] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [tol, setTol] = useState('');
  const [ig, setIg] = useState('');
  // Ha be van pipálva, az utazás a "Repülős utak" kategóriába kerül
  const [repulos, setRepulos] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdmin = useSelector(state => state.permission.isAdmin);
  const url = process.env.REACT_APP_API_URL;
    const modules = {
        toolbar: [
          [{ 'font': [] }],
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['clean']
        ]
      };
      
      const formats = [
        'font',
        'header',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'list', 'bullet'
      ];
  
  // Külön állapot a háttérképhez: lehet fájl vagy URL (string)
  const [backgroundFile, setBackgroundFile] = useState(null);
  const [backgroundLink, setBackgroundLink] = useState('');

  // Galéria képek: fájlok és linkek
  const [galleryFiles, setGalleryFiles] = useState([]);
  const [galleryLinks, setGalleryLinks] = useState(['']); // Kezdetben egy üres input mező

  const handleBackgroundFileChange = (e) => {
    setBackgroundFile(e.target.files[0]);
  };

  const removeBackgroundFile = () => {
    setBackgroundFile(null);
  };

  const handleGalleryFilesChange = (e) => {
    // Az újonnan kiválasztott fájlokat hozzáadjuk a már létezőkhöz.
    // (Ha felülírni szeretnéd a meglévőket, akkor setGalleryFiles([...e.target.files]) is lehet.)
    setGalleryFiles([...galleryFiles, ...Array.from(e.target.files)]);
  };

  const removeGalleryFile = (index) => {
    setGalleryFiles(galleryFiles.filter((_, i) => i !== index));
  };

  // Kezeljük a linkek változását a galéria linkekhez:
  const handleGalleryLinkChange = (index, value) => {
    const newLinks = [...galleryLinks];
    newLinks[index] = value;
    setGalleryLinks(newLinks);
  };

  // Új galéria link mező hozzáadása:
  const addGalleryLinkField = () => {
    if (galleryLinks.length < 10) {
      setGalleryLinks([...galleryLinks, '']);
    }
  };

  // Form adatok beküldése:
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Használj FormData-t, ha fájlokat is küldesz:
    const formData = new FormData();
    formData.append('title', destination);
    formData.append('description', description);
    formData.append('price', price);
    formData.append('tol', tol);
    formData.append('ig', ig);
    formData.append('repulos', repulos ? 'true' : 'false');


    // Háttérkép: fájl vagy URL
    if (backgroundFile) {
      formData.append('backgroundFile', backgroundFile);
    } else if (backgroundLink) {
      formData.append('backgroundLink', backgroundLink);
    }
    
    // Galéria képek: fájlok és linkek
    if (galleryFiles.length > 0) {
      galleryFiles.forEach((file) => {
        formData.append('galleryFiles', file);
      });
    }
    galleryLinks.forEach((link, index) => {
      if (link.trim() !== "") {
        formData.append(`galleryLinks[${index}]`, link);
      }
    });

    try {
      const response = await fetch(url + '/api/utazasok', {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      if (response.ok) {
        console.log('Utazás és képek sikeresen feltöltve');
        alert('Utazás és képek sikeresen feltöltve');
        navigate('/admin'); // Navigálj vissza az admin oldalra vagy egy másik oldalra
        // Itt resetelheted a formot, ha szükséges
      }
    } catch (error) {
      console.error('Hiba a feltöltés során:', error);
      alert('Hiba a feltöltés során');
    }
  };

  if (!isAdmin) {
    return (
      <div className="error">
        Hozzáférés megtagadva. Csak adminisztrátorok számára elérhető.
      </div>
    );
  }

  return (
    <div className="travel-upload-container">
      <form onSubmit={handleSubmit}>
        <h2>Új utazás hozzáadása</h2>
        
        <label>Utazás (Címe) célpontja:</label>
        <input 
          type="text" 
          value={destination}
          onChange={(e) => setDestination(e.target.value)}
          required
        />

        <label>Ár:</label>
        <input 
          type="text" 
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
        />

        <label>Időpont: (tól-ig)</label>
                <input 
                type="date" 
                value={tol}
                onChange={(e) => setTol(e.target.value)}
                required
                />
                 <input 
                type="date" 
                value={ig}
                onChange={(e) => setIg(e.target.value)}
                required
                />

        <label className="repulos-checkbox">
          <input
            type="checkbox"
            checked={repulos}
            onChange={(e) => setRepulos(e.target.checked)}
          />
          <span className="repulos-checkbox__icon" aria-hidden="true">✈</span>
          <span className="repulos-checkbox__text">
            Repülős út
            <small>Bepipálva a „Repülős utak” közé kerül, az egy/több napos listákban nem jelenik meg.</small>
          </span>
        </label>

       <label>Leírás:</label>
               {/* ReactQuill szerkesztő */}
               <ReactQuill 
                 theme="snow" 
                 value={description} 
                 onChange={setDescription} 
                 modules={modules}
                 formats={formats}
               />

        <h3>Háttérkép</h3>
        <label>Feltöltés: </label>
        <input 
          type="file" 
          onChange={handleBackgroundFileChange} 
          accept="image/*"
        />
        {backgroundFile && (
          <div className="background-preview">
            <img 
              src={URL.createObjectURL(backgroundFile)} 
              alt="Háttérkép előnézet" 
              width="100" 
              height="100"
            />
            <button className="torles-gomb" type="button" onClick={removeBackgroundFile}>Törlés</button>
          </div>
        )}
        <p>Vagy add meg az URL-t:</p>
        <input 
          type="url" 
          placeholder="Háttérkép URL"
          value={backgroundLink}
          onChange={(e) => setBackgroundLink(e.target.value)}
        />

        <h3>Galéria képek</h3>
        <label>Feltöltés (több fájl is):</label>
        <input 
          type="file" 
          onChange={handleGalleryFilesChange} 
          accept="image/*"
          multiple
        />
        {galleryFiles.length > 0 && (
          <div className="gallery-previews">
            {galleryFiles.map((file, index) => (
              <div key={index} className="gallery-preview">
                <img 
                  src={URL.createObjectURL(file)} 
                  alt={`Galéria kép előnézet ${index + 1}`} 
                  width="100" 
                  height="100"
                />
                <button className='torles-gomb' type="button" onClick={() => removeGalleryFile(index)}>Törlés</button>
              </div>
            ))}
          </div>
        )}
        <p>Vagy add meg a képek URL-jeit:</p>
        {galleryLinks.map((link, index) => (
          <div key={index}>
            <input 
              type="url"
              placeholder={`Kép URL ${index + 1}`}
              value={link}
              onChange={(e) => handleGalleryLinkChange(index, e.target.value)}
            />
          </div>
        ))}
        {galleryLinks.length < 10 && (
          <button className="gallery_link" type="button" onClick={addGalleryLinkField}>
            Új URL mező
          </button>
        )}

        <button className="submit-gomb" type="submit">Elküld</button>
      </form>
    </div>
  );
}
